import { copyToClipboard } from '@/utils';
import { Box, Button, Typography } from '@mui/material';
import React, { useState } from 'react';
import { toast } from 'react-hot-toast';
import { useTranslation } from 'next-i18next';
import {
  GlobalSeedContent,
  GlobalSeedWrapper,
  SectionTitle,
  SectionWrapper,
} from '../styles';
import RoundHistoryTable from './RoundHistoryTable';

const XCrash: React.FC = () => {
  const { t } = useTranslation();
  const [globalSeed, setGlobalSeed] = useState<string>(
    '0x00000000000000000004ab6468e03c35500b5f59b8ef58ef9873f67ffbf12bcd',
  );
  const handleCopy = () => {
    copyToClipboard(globalSeed).then(() => {
      console.log('copy success');
      toast.success(t('COPY SUCCESS'));
    });
  };

  return (
    <SectionWrapper>
      <SectionTitle>{t('CRASH')}</SectionTitle>
      <GlobalSeedWrapper>
        <Typography variant={'body2'}>{t('Global Seed')}</Typography>
        <GlobalSeedContent>
          <span>{globalSeed}</span>
          <Button variant="plain" sx={{ height: '32px' }} onClick={handleCopy}>
            {t('COPY')}
          </Button>
        </GlobalSeedContent>
      </GlobalSeedWrapper>
      <Box sx={{ mt: 5 }}>
        <RoundHistoryTable />
      </Box>
    </SectionWrapper>
  );
};

export default XCrash;
